module.exports = require('../../full/object/define-property');
